import React from "react";

const SoundIcon = ({className = "", restProps}) => {
  return (
      <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg"
           className={className}
           {...restProps}
      >
        <path fillRule="evenodd" clipRule="evenodd"
              d="M7.16487 1.02885L3.2 4.60983H0.5C0.223858 4.60983 0 4.83368 0 5.10983V9.89016C0 10.1663 0.223858 10.3902 0.5 10.3902H3.2L7.16487 13.9711C7.48643 14.2616 8 14.0334 8 13.6001V1.39991C8 0.966608 7.48643 0.738421 7.16487 1.02885Z"
              fill="#303030"/>
        <path d="M10.0006 10C10.5977 9.50037 10.9994 8.56753 10.9994 7.49921C10.9994 6.43202 10.5986 5.50001 10.0025 5"
              className="round" stroke="#303030" strokeLinecap="round"/>
        <path d="M12 14C13.766 12.701 15 10.2776 15 7.5C15 4.72529 13.7685 2.30003 12.0055 1" stroke="#303030"
              className="round" strokeLinecap="round"/>
      </svg>
  )
};

export default SoundIcon
